export default __webpack_public_path__ + "static/media/pop-up.7b65e98a.svg";